<template>
    <section class="section_emploees">
        <div class="header_emploee">
            <p class="characteristics_title_meter">
                Передовики
            </p>
            <div class="box_button_header_emploee">
                <div class="box_button_back_emploee">
                    <RouterLink
                        to="/employees"
                        class="button_standart"
                    >
                        Вернуться
                    </RouterLink>
                </div>
                <ModalHeader />
            </div>
        </div>
        <div class="section_advanced">
            <div class="container_advanced">
                <AdvancedBox
                    v-for="(employee, index) in employees"
                    :key="employee.id || index"
                    :employee="employee"
                />
            </div>
            <div class="container_advanced_text">
                <p class="characteristics_indentation_text color_orange">
                    Спасибо за ваш труд!
                </p>
                <p class="font_16_500_Montserrat_SemiBold thank-you-message">
                    {{ thankYouMessage }}
                </p>
            </div>
        </div>
    </section>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import ModalHeader from '@/shared/components/modal-header/ModalHeader.vue';
import {
    AdvancedBox,
} from './components';
import { API_ENDPOINTS } from '@/shared/constants';

const employees = ref([]);

const thankYouMessage = `Золотые руки и светлая, грамотная голова всегда в почёте. Где бы
человек ни находился, он найдёт себе применение и заслужит уважение.
Примите сердечную благодарность за проделанную работу, выполненную
профессионально, на самом высоком уровне. Пусть удача сопутствует вам
во всех начинаниях!\n\n
Трудитесь, развивайтесь, желаем вам процветания и успехов!\n\n
Директор ЛК "Шкуренко"`;

const fetchAdvanced = async () => {
    try {
        const response = await fetch(`${API_ENDPOINTS.LEADERS}?pageSize=100`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        if (data && data.items && Array.isArray(data.items)) {
            employees.value = data.items.map(item => ({
                id: item.id,
                name: item.name,
                achievement: item.achievement,
                image: item.photo,
                createdAt: item.createdAt,
                updatedAt: item.updatedAt,
            }));
        } else {
            employees.value = [];
        }

    } catch (e) {
        console.error('Ошибка при загрузке передовиков:', e);
        employees.value = [];
    }
};

onMounted(() => {
    fetchAdvanced();
});
</script>

<style scoped>
.thank-you-message {
    white-space: pre-line;
}

@media (max-width: 767px) {
    .section_advanced {
        align-items: stretch;
        gap: 2rem;
    }

    .container_advanced_text {
        display: flex;
        order: -1;
        width: 100%;
        max-width: none;
    }
}
</style>
